import React, {useEffect, useState} from "react";

import * as AssetsService from "../../api/AssetsService"
import styles from "./MyCardsMenu.module.css"
import AddIcon from '@mui/icons-material/Add';
import VisibilityOffOutlined from '@mui/icons-material/VisibilityOffOutlined';
import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import {useTranslation} from "react-i18next";

export default function MyCardsMenu(props) {
    const [allDecks, setAllDecks] = useState([])
    const [fetchComplete, setFetchComplete] = useState(false)
    const { t } = useTranslation('translation', { keyPrefix: 'myCardsMenu' });

    useEffect(() => {
        AssetsService.getAllCustomDecks((jres) => {
            setAllDecks(jres)
            setFetchComplete(true)
        }, () => {
            props.onUnathorized()
        })
    }, [])

    function getItemStyle(counter) {
        return Object.assign({
            animationDuration: "0.4s",
            animationDelay: counter*0.1 + "s",
        })
    }

    return (
        <>
            {fetchComplete && <div className={styles.menuContainer}>
                <div
                    className={styles.menuItem}
                    style={getItemStyle(0)}
                    onClick={() => props.setCurrentView("custom_deck_new")}
                >
                    <AddIcon/> {t('createNewDeck')}
                </div>
                {allDecks.map((deck, index) => {
                    return <div
                        key={deck.id}
                        className={styles.menuItem}
                        style={getItemStyle(index + 1)}
                        onClick={() => {
                            props.setCurrentView("custom_deck_edit")
                            props.setSelectedDeck(deck.id)
                        }}
                    >
                        <AppRegistrationOutlinedIcon/> {deck.name}
                    </div>
                })}
                <div
                    className={styles.menuItem}
                    style={getItemStyle(allDecks.length + 2)}
                    onClick={() => {props.setCurrentView("private_notes")}}
                >
                    <VisibilityOffOutlined/> {t('privateNotes')}
                </div>
            </div>}
        </>
    )
}


